import DashboardAsync from '../pages/Dashboard/DashboardAsync';
import GameLaunchHeaderAsync from '../components/GameLaunch/GameLaunchHeader/GameLaunchHeaderAsync';
import GameLaunchHeaderMobileAsync from '../components/GameLaunch/GameLaunchHeaderMobile/GameLaunchHeaderMobileAsync';
import HeaderAsync from '../components/Header/HeaderAsync';
import BurgerIconAsync from '../components/Button/BurgerIcon/BurgerIconAsync';
import GameCardAsync from '../components/GameCard/GameCardBaseAsync';
import NoContentAsync from '../components/NoContent/NoContentAsync';
import NavigationAsync from '../components/Navigation/NavigationAsync';
import BaseLayoutAsync from '../layouts/BaseLayout/BaseLayoutAsync';
import NavigationModalAsync from '../components/Navigation/NavigationModal/NavigationModalAsync';
import GameCardsLineCategoryAsync from '../components/GameCardsLine/GameCardsLineCategory/GameCardsLineCategoryAsync';
import ErrorPageAsync from '../pages/ErrorPage/ErrorPageAsync';
import GameCardsLineRecentLaunched from '../components/GameCardsLine/GameCardsLineRecentLaunched/GameCardsLineRecentLaunched';
import GameCardsLineProvider from '../components/GameCardsLine/GameCardsLineProvider/GameCardsLineProvider';
import GameCardsLineTheme from '../components/GameCardsLine/GameCardsLineTheme/GameCardsLineTheme';
import BonusGamesWageringAsync from '../pages/BonusGamesWagering/BonusGamesWageringAsync';

import DashboardAsyncSCCOM from '../AppSCCOM/pages/Dashboard/DashboardAsync';
import GameLaunchHeaderAsyncSCCOM from '../AppSCCOM/components/GameLaunch/GameLaunchHeader/GameLaunchHeaderAsync';
import GameLaunchHeaderMobileAsyncSCCOM from '../AppSCCOM/components/GameLaunch/GameLaunchHeaderMobile/GameLaunchHeaderMobileAsync';
import HeaderAsyncSCCOM from '../AppSCCOM/components/Header/HeaderAsync';
import BurgerIconAsyncSCCOM from '../AppSCCOM/components/Button/BurgerIcon/BurgerIconAsync';
import GameCardSCCOM from '../AppSCCOM/components/GameCard/GameCardAsync';
import NoContentAsyncSCCOM from '../AppSCCOM/components/NoContent/NoContentAsync';
import NavigationAsyncSCCOM from '../AppSCCOM/components/NavigationAside/NavigationAsync';
import BaseLayoutAsyncSCCOM from '../AppSCCOM/layouts/BaseLayout/BaseLayoutAsync';
import ErrorPageAsyncSCCOM from '../AppSCCOM/pages/ErrorPage/ErrorPageAsync';
import NavigationModalAsyncSCCOM from '../AppSCCOM/components/NavigationAside/NavigationModal/NavigationModalAsync';
import GameCardsLineCategoryAsyncSCCOM from '../AppSCCOM/components/GameCardsWidget/GameCardsWidgetCategory/GameCardsWidgetCategoryAsync';
import GameCardsWidgetRecentLaunchedAsyncSCCOM from '../AppSCCOM/components/GameCardsWidget/GameCardsWidgetRecentLaunched/GameCardsWidgetRecentLaunchedAsync';
import GameCardsWidgetProviderAsyncSCCOM from '../AppSCCOM/components/GameCardsWidget/GameCardsWidgetProvider/GameCardsWidgetProviderAsync';
import GameCardsWidgetAsyncSCCOM from '../AppSCCOM/components/GameCardsWidget/GameCardsWidget/GameCardsWidgetAsync';
import BonusGamesWageringSCCOMAsync from '../AppSCCOM/pages/BonusGamesWagering/BonusGamesWageringAsync';
import SeoPageHeading from '../AppSCCOM/components/SEOWrapper/SeoPageHeading';

import { SCCOM_BRAND } from './noNameBrands';

export const DASHBOARD_LIST = {
  [SCCOM_BRAND]: DashboardAsyncSCCOM,
  default: DashboardAsync,
};

export const GAME_HEADER_LIST = {
  [SCCOM_BRAND]: GameLaunchHeaderAsyncSCCOM,
  default: GameLaunchHeaderAsync,
};

export const GAME_HEADER_MOBILE_LIST = {
  [SCCOM_BRAND]: GameLaunchHeaderMobileAsyncSCCOM,
  default: GameLaunchHeaderMobileAsync,
};

export const HEADER_BRAND_CONFIG = {
  [SCCOM_BRAND]: HeaderAsyncSCCOM,
  default: HeaderAsync,
};

export const BURGER_ICON_BRAND_CONFIG = {
  [SCCOM_BRAND]: BurgerIconAsyncSCCOM,
  default: BurgerIconAsync,
};

export const GAME_CARD_BRAND_CONFIG = {
  [SCCOM_BRAND]: GameCardSCCOM,
  default: GameCardAsync,
};

export const NO_CONTENT_WIDGET_COLLECTION = {
  [SCCOM_BRAND]: NoContentAsyncSCCOM,
  default: NoContentAsync,
};

export const NAVIGATION_WIDGET_COLLECTION = {
  [SCCOM_BRAND]: NavigationAsyncSCCOM,
  default: NavigationAsync,
};

export const NAVIGATION_MODAL_WIDGET_COLLECTION = {
  [SCCOM_BRAND]: NavigationModalAsyncSCCOM,
  default: NavigationModalAsync,
};

export const BASE_LAYOUT_LIST = {
  [SCCOM_BRAND]: BaseLayoutAsyncSCCOM,
  default: BaseLayoutAsync,
};

export const ERROR_PAGE_COLLECTION = {
  [SCCOM_BRAND]: ErrorPageAsyncSCCOM,
  default: ErrorPageAsync,
};

export const GAME_CARDS_LINE_CATEGORY_COLLECTION = {
  [SCCOM_BRAND]: GameCardsLineCategoryAsyncSCCOM,
  default: GameCardsLineCategoryAsync,
};

export const GAME_CARDS_RECENT_LAUNCH = {
  [SCCOM_BRAND]: GameCardsWidgetRecentLaunchedAsyncSCCOM,
  default: GameCardsLineRecentLaunched,
};

export const GAME_CARDS_PROVIDER = {
  [SCCOM_BRAND]: GameCardsWidgetProviderAsyncSCCOM,
  default: GameCardsLineProvider,
};

export const GAME_CARDS_THEME = {
  [SCCOM_BRAND]: GameCardsWidgetAsyncSCCOM,
  default: GameCardsLineTheme,
};

export const BONUS_GAMES_WAGERING = {
  [SCCOM_BRAND]: BonusGamesWageringSCCOMAsync,
  default: BonusGamesWageringAsync,
};

export const PAGE_TITLE_HEADING = {
  [SCCOM_BRAND]: SeoPageHeading,
  default: 'h1',
};
